import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { deepExtend, executeOnSingleOrMultiple, isBoolean, safeMatchMedia } from "../../Utils/Utils";
import { Background } from "./Background/Background";
import { BackgroundMask } from "./BackgroundMask/BackgroundMask";
import { FullScreen } from "./FullScreen/FullScreen";
import { Interactivity } from "./Interactivity/Interactivity";
import { ManualParticle } from "./ManualParticle";
import { Responsive } from "./Responsive";
import { Theme } from "./Theme/Theme";
import { loadParticlesOptions } from "../../Utils/OptionsUtils";
import { setRangeValue } from "../../Utils/NumberUtils";
export var Options = /*#__PURE__*/function () {
  function Options(engine, container) {
    var _this = this;

    _classCallCheck(this, Options);

    this._findDefaultTheme = function (mode) {
      var _this$themes$find;

      return (_this$themes$find = _this.themes.find(function (theme) {
        return theme.default.value && theme.default.mode === mode;
      })) !== null && _this$themes$find !== void 0 ? _this$themes$find : _this.themes.find(function (theme) {
        return theme.default.value && theme.default.mode === "any";
      });
    };

    this._importPreset = function (preset) {
      _this.load(_this._engine.plugins.getPreset(preset));
    };

    this._engine = engine;
    this._container = container;
    this.autoPlay = true;
    this.background = new Background();
    this.backgroundMask = new BackgroundMask();
    this.defaultThemes = {};
    this.delay = 0;
    this.fullScreen = new FullScreen();
    this.detectRetina = true;
    this.duration = 0;
    this.fpsLimit = 120;
    this.interactivity = new Interactivity(engine, container);
    this.manualParticles = [];
    this.particles = loadParticlesOptions(this._engine, this._container);
    this.pauseOnBlur = true;
    this.pauseOnOutsideViewport = true;
    this.responsive = [];
    this.smooth = false;
    this.style = {};
    this.themes = [];
    this.zLayers = 100;
  }

  _createClass(Options, [{
    key: "backgroundMode",
    get: function get() {
      return this.fullScreen;
    },
    set: function set(value) {
      this.fullScreen.load(value);
    }
  }, {
    key: "fps_limit",
    get: function get() {
      return this.fpsLimit;
    },
    set: function set(value) {
      this.fpsLimit = value;
    }
  }, {
    key: "retina_detect",
    get: function get() {
      return this.detectRetina;
    },
    set: function set(value) {
      this.detectRetina = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      var _this2 = this,
          _data$detectRetina,
          _data$fpsLimit,
          _data$fullScreen,
          _this$_findDefaultThe,
          _this$_findDefaultThe2;

      if (!data) {
        return;
      }

      if (data.preset !== undefined) {
        executeOnSingleOrMultiple(data.preset, function (preset) {
          return _this2._importPreset(preset);
        });
      }

      if (data.autoPlay !== undefined) {
        this.autoPlay = data.autoPlay;
      }

      if (data.delay !== undefined) {
        this.delay = setRangeValue(data.delay);
      }

      var detectRetina = (_data$detectRetina = data.detectRetina) !== null && _data$detectRetina !== void 0 ? _data$detectRetina : data.retina_detect;

      if (detectRetina !== undefined) {
        this.detectRetina = detectRetina;
      }

      if (data.duration !== undefined) {
        this.duration = setRangeValue(data.duration);
      }

      var fpsLimit = (_data$fpsLimit = data.fpsLimit) !== null && _data$fpsLimit !== void 0 ? _data$fpsLimit : data.fps_limit;

      if (fpsLimit !== undefined) {
        this.fpsLimit = fpsLimit;
      }

      if (data.pauseOnBlur !== undefined) {
        this.pauseOnBlur = data.pauseOnBlur;
      }

      if (data.pauseOnOutsideViewport !== undefined) {
        this.pauseOnOutsideViewport = data.pauseOnOutsideViewport;
      }

      if (data.zLayers !== undefined) {
        this.zLayers = data.zLayers;
      }

      this.background.load(data.background);
      var fullScreen = (_data$fullScreen = data.fullScreen) !== null && _data$fullScreen !== void 0 ? _data$fullScreen : data.backgroundMode;

      if (isBoolean(fullScreen)) {
        this.fullScreen.enable = fullScreen;
      } else {
        this.fullScreen.load(fullScreen);
      }

      this.backgroundMask.load(data.backgroundMask);
      this.interactivity.load(data.interactivity);

      if (data.manualParticles) {
        this.manualParticles = data.manualParticles.map(function (t) {
          var tmp = new ManualParticle();
          tmp.load(t);
          return tmp;
        });
      }

      this.particles.load(data.particles);
      this.style = deepExtend(this.style, data.style);

      this._engine.plugins.loadOptions(this, data);

      if (data.smooth !== undefined) {
        this.smooth = data.smooth;
      }

      var interactors = this._engine.plugins.interactors.get(this._container);

      if (interactors) {
        var _iterator = _createForOfIteratorHelper(interactors),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var interactor = _step.value;

            if (interactor.loadOptions) {
              interactor.loadOptions(this, data);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      if (data.responsive !== undefined) {
        var _iterator2 = _createForOfIteratorHelper(data.responsive),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var responsive = _step2.value;
            var optResponsive = new Responsive();
            optResponsive.load(responsive);
            this.responsive.push(optResponsive);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      this.responsive.sort(function (a, b) {
        return a.maxWidth - b.maxWidth;
      });

      if (data.themes !== undefined) {
        var _iterator3 = _createForOfIteratorHelper(data.themes),
            _step3;

        try {
          var _loop = function _loop() {
            var theme = _step3.value;

            var existingTheme = _this2.themes.find(function (t) {
              return t.name === theme.name;
            });

            if (!existingTheme) {
              var optTheme = new Theme();
              optTheme.load(theme);

              _this2.themes.push(optTheme);
            } else {
              existingTheme.load(theme);
            }
          };

          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }

      this.defaultThemes.dark = (_this$_findDefaultThe = this._findDefaultTheme("dark")) === null || _this$_findDefaultThe === void 0 ? void 0 : _this$_findDefaultThe.name;
      this.defaultThemes.light = (_this$_findDefaultThe2 = this._findDefaultTheme("light")) === null || _this$_findDefaultThe2 === void 0 ? void 0 : _this$_findDefaultThe2.name;
    }
  }, {
    key: "setResponsive",
    value: function setResponsive(width, pxRatio, defaultOptions) {
      this.load(defaultOptions);
      var responsiveOptions = this.responsive.find(function (t) {
        return t.mode === "screen" && screen ? t.maxWidth > screen.availWidth : t.maxWidth * pxRatio > width;
      });
      this.load(responsiveOptions === null || responsiveOptions === void 0 ? void 0 : responsiveOptions.options);
      return responsiveOptions === null || responsiveOptions === void 0 ? void 0 : responsiveOptions.maxWidth;
    }
  }, {
    key: "setTheme",
    value: function setTheme(name) {
      if (name) {
        var chosenTheme = this.themes.find(function (theme) {
          return theme.name === name;
        });

        if (chosenTheme) {
          this.load(chosenTheme.options);
        }
      } else {
        var mediaMatch = safeMatchMedia("(prefers-color-scheme: dark)"),
            clientDarkMode = mediaMatch && mediaMatch.matches,
            defaultTheme = this._findDefaultTheme(clientDarkMode ? "dark" : "light");

        if (defaultTheme) {
          this.load(defaultTheme.options);
        }
      }
    }
  }]);

  return Options;
}();